(function($,document,undefined){
	//自定义组件 单选，多选
	(function(){
		$(document).on('change','[type="checkbox"][data-custom="w"]',function(){
			//自定义复选框
			var $this	=	$(this);

			if(!$this.is(':disabled')){
				if($this.is(':checked')){
					//$this.parent().attr('class','checkbox_checked');
					$this.parent().removeClass('checkbox_default').addClass('checkbox_checked');
				}
				else{
					//$this.parent().attr('class','checkbox_default');
					$this.parent().removeClass('checkbox_checked').addClass('checkbox_default');
				};
			}
		}).on('change','[type="radio"][data-custom="w"]',function(){
			//自定义单选框
			var $this	=	$(this),
				$these	=	$('input[name='+$this.attr('name')+']').not(':disabled');

			if(!$this.is(':disabled')){
				/*if($this.is(':checked')){
					$these.each(function(){
						var $this	=	$(this);
						!$this.is(':disabled')	&&	$this.parent().attr('class','radio_default');
					});
					$this.parent().attr('class','radio_checked');
				}
				else{
					$this.parent().attr('class','radio_default');
				};*/
				$these.each(function(){
					$(this).parent().removeClass('radio_default').removeClass('radio_checked').addClass('radio_default');
				});
				$this.parent().removeClass('radio_default').addClass('radio_checked');
			}
		});
	})();
	//全选
	(function(){
		if(!$('[data-select="all"]').length) return false;
		$(document).on('click','[data-select="all"]',function(){
				//全选与子项
				var	$this	=	$(this),
					$org	=	$('[data-select="sub"][data-org='+$this.data('org')+']');

				if($this.is(':checked')){
					$this.prop('checked',true).change();
					$org.each(function(){
						!$(this).is(':checked')	&&	$(this).click();
					});
				}
				else{
					$this.prop('checked',false).change();
					$org.each(function(){
						$(this).is(':checked')	&&	$(this).click();
					});
				};
			}).on('click','[data-select="sub"]',function(){
				//子项与全选
				var	$this	=	$(this),
					$org	=	$('[data-select="sub"][data-org='+$this.data('org')+']'),
					$all	=	$('[data-select="all"][data-org='+$this.data('org')+']'),
					$subchk	=	$('[data-select="sub"][data-org='+$this.data('org')+']:checked');
				if($this.is(':checked')	&&	$org.length == $subchk.length){
					$all.prop('checked',true).change();
				}
				else{
					$all.prop('checked',false).change();
				};
			});
	})();

	/**************
	/**时间控件

	需要调用控件的input添加自定义属性：data-pickerindex


	配置参数：
	最大视图		maxAccording		:	1~5 (分别对应年/月/日/时/分)
	最小视图		minAccording		:	同上
	起始视图		startingPosition	：	同上
	选择后自动关闭	autoClose			：	true/false
	是否有图标		icon				:	ture/false

	暴露方法：
	-1、定义一个时间控件对象
		$([data-pickerindex]).dateBox(obj);
			obj	=	""	or	obj	=	{	"maxAccording"	:	1};
    0、初始化控件
        $(selector).dateBox("init");
	1、设置控件起始时间（默认且最小值1900-1-1 0:00）
		$(selector).dateBox('setStartDate',dateString);
		参数：dateString	必须值，格式'yyyy-mth-date' or 'yyyy-mth-date hh:mm'	e.g. '2016-09-23'	or	'2016-3-1 13:15'
	2、设置控件截止时间（默认且最大值2099-12-31 23:59）
		$(selector).dateBox('setEndDate',dateString);
		参数：dateString	必须值	e.g. '2016-09-23'	or	'2016-3-1 0:15'
	3、将选择日期更新到input框
		$(selector).dateBox('update');
	4、将input框已有值传入控件
		$(selector).dateBox('show');
	5、看心情(╯‵□′)╯︵┻━┻
	**************/
	var w_Date	=	function(_this,setting,element,_icon){
		var today		=	new Date(),
			$this		=	element,
			$icon		=	_icon,
			that		=	this,
			$input		=	$(_this),
			$wrap		=	$input.closest('.w_dateWrap'),
			nowYear		=	today.getFullYear(),
			nowMonth	=	today.getMonth(),	//	正常值 -1，与其他传入数据做处理时要记得咧
			nowDate		=	today.getDate(),
			nowHour		=	today.getHours(),
			nowMinute	=	today.getMinutes(),
			startingPosition,		//起始选择点
			maxAccording,		//最大选择点
			minAccording,		//最小选择点
			autoClose,icon,
			startDate	=	{
				"year"	:	1900,
				"month"	:	1,
				"date"	:	1,
				"hour"	:	0,
				"minute":	"00"
			},
			endDate		=	{
				"year"	:	2099,
				"month"	:	12,
				"date"	:	31,
				"hour"	:	23,
				"minute":	"59"
			},
			timeout;
		//显示 时间 年月
		var printYearMonth	=	function(){
				var html	=	"<div class='w_dateTime'>"	+
									"<div class='w_right J_w_nextMth'>></div>"	+
									"<div class='w_left	J_w_prevMth'><</div>"	+
									"<div class='w_yearMonth J_w_month'>"	+
										nowYear	+	"年"	+	(nowMonth+1)	+	"月"	+
									"</div>"	+
								"</div>";
				$this.html(html);
				outOfDates("YM");
		};
		var beforeEndDate	=	function(_date,according){
			var a	=	new Date(),
				b	=	new Date();
			if(according	>=	1){
				a.setFullYear(_date.year);
				b.setFullYear(endDate.year);
				if(according	>=	2){
					a.setMonth(_date.month-1);
					b.setMonth(endDate.month-1);
					if(according	>=	3){
						a.setDate(_date.date);
						b.setDate(endDate.date);
						if(according	>=	4){
							a.setHours(_date.hour);
							b.setHours(endDate.hour);
							if(according	>=	5){
								a.setMinutes(_date.minute);
								b.setMinutes(endDate.minute);
							}
							else{
								a.setMinutes(0);
								b.setMinutes(0);
							};
						}
						else{
							a.setHours(0);
							b.setHours(0);
						};
					}
					else{
						a.setDate(1);
						b.setDate(1);
					};
				}
				else{
					a.setMonth(0);
					b.setMonth(0);
				};
			}
			else{
				a.setFullYear(nowYear);
				b.setFullYear(endDate.year);
			};
			a.setSeconds(0);
			b.setSeconds(0);
			var flag	=	 (a.valueOf()	<=	b.valueOf())	?	true	:	false;
			return flag;
		};
		var afterStartDate	=	function(_date,according){
			var a	=	new Date(),
				b	=	new Date();
			if(according	>=	1){
				a.setFullYear(_date.year);
				b.setFullYear(startDate.year);
				if(according	>=	2){
					a.setMonth(_date.month-1);
					b.setMonth(startDate.month-1);
					if(according	>=	3){
						a.setDate(_date.date);
						b.setDate(startDate.date);
						if(according	>=	4){
							a.setHours(_date.hour);
							b.setHours(startDate.hour);
							if(according	>=	5){
								a.setMinutes(_date.minute);
								b.setMinutes(startDate.minute);
							}
							else{
								a.setMinutes(0);
								b.setMinutes(0);
							};
						}
						else{
							a.setHours(0);
							b.setHours(0);
						};
					}
					else{
						a.setDate(1);
						b.setDate(1);
					};
				}
				else{
					a.setMonth(0);
					b.setMonth(0);
				};
			}
			else{
				a.setFullYear(nowYear);
				b.setFullYear(startDate.year);
			};
			a.setSeconds(0);
			b.setSeconds(0);
			var flag	=	 (a.valueOf()	>=	b.valueOf())	?	true	:	false;
			return flag;
		};
		//print select Month Box
		var printMonth	=	function(){
			var html	=	"<div class='w_dateTime'>"	+
								"<div class='w_right J_w_nextYear'>></div>"	+
								"<div class='w_left J_w_prevYear'><</div>"	+
								"<div class='w_yearMonth J_w_year'>"	+
									nowYear	+	"年"	+
								"</div>"	+
							"</div>"	+
							"<div class='w_dateContainer'>"	+
								"<div class='w_title'>"	+	"选择月份"	+	"</div>"	+
								"<div class='w_selectBox'>"	+
									"<ul class='month'>",
				month	=	["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"];
			for(var i	=	0;	i	<	month.length;	i++){
				var	obj	=	{"year" : nowYear,	"month" : i+1};
				if(beforeEndDate(obj,2)	&&	afterStartDate(obj,2)){
					if(nowYear	==	today.getFullYear()	&&	i	==	today.getMonth())
						html	+=			"<li class='today' data-month='"	+	i	+	"'>"	+	month[i]	+	"</li>";
					else
						html	+=			"<li data-month='"	+	i	+	"'>"	+	month[i]	+	"</li>";
				}
				else{
					html	+=	"<li class='gray'>"	+	month[i]	+	"</li>";
				};
			};
			html	+=				"</ul>"	+
								"</div>"	+
							"</div>";
			$this.html(html);
			outOfDates("Y");
		};
		//显示 时间 月历
		var printDays	=	function(){
			var html		=	"",
				htmlTitle	=	"",
				week		=	["周日","周一","周二","周三","周四","周五","周六"],
				liLength	=	0,
				firstDate	=	new Date(),
				dates,day,prevMonthDates;
			firstDate.setDate(1);
			firstDate.setMonth(nowMonth);
			firstDate.setFullYear(nowYear);
			day				=	firstDate.getDay()	?	firstDate.getDay()	:	7;
			dates			=	getMonthArr(nowYear)[nowMonth];
			prevMonthDates	=	getPrevMonthDates();
			//day	=	day	?	day	:	7;
			//格式为	7	*	6	的格子
			//在该月第一天前填充上个月的最后几天
			for(var i	=	prevMonthDates	-	day	+	1;	i	<=	prevMonthDates;	i++){
				html	+=	"<li class='gray'>"	+	i	+	"</li>";
				liLength++;
			};
			//填充该月日期
			for(var i	=	1;	i	<=	dates;	i++){
				var obj	=	{"year" : nowYear,	"month" : nowMonth+1,	"date" : i};
				if(beforeEndDate(obj,3)	&&	afterStartDate(obj,3)){
					if(nowYear	==	today.getFullYear()	&&	nowMonth	==	today.getMonth()	&&	i	==	today.getDate())
						html	+=	"<li class='today' data-date='"	+	i	+	"'>"	+	i	+	"</li>";
					else
						html	+=	"<li data-date='"	+	i	+	"'>"	+	i	+	"</li>";
				}
				else
					html	+=	"<li class='gray'>"	+	i	+	"</li>";
				liLength++;
			};
			//填充下个月的前几天
			for(var i	=	1;	liLength	<	42;	i++){
				html	+=	"<li class='gray'>"	+	i	+	"</li>";
				liLength++;
			};
			//print title
			htmlTitle	=	"<div class='w_title'>"	+
								"<ul>";
			for(var i	=	0; i	<	week.length;	i++){
				htmlTitle	+=	"<li>"	+	week[i]	+	"</li>";
			};
			htmlTitle	+=		"</ul>"	+
							"</div>";
			var htmlAll	=	"<div class='w_dateContainer'>"	+
								htmlTitle	+
								"<div class='w_selectBox'>"	+
									"<ul class='date'>"	+	html	+	"</ul>"	+
								"</div>"	+
							"</div>";
			$this.append(htmlAll);
			outOfDates("YMD");
		};
		//上个月天数
		var getPrevMonthDates	=	function(){
			var prevMonth,year;
			if(nowMonth	==	0){
				prevMonth	=	11;
				year		=	nowYear	-	1;
			}
			else{
				prevMonth	=	nowMonth	-	1;
				year		=	nowYear;
			};
			return getMonthArr(year)[prevMonth];
		};
		//判断是否闰年
		var isLeapYear	=	function(year){
			if(year%400==0	||	(year%4==0	&& year%100))
				return true;
			else
				return false;
		};
		//获取月份对应的天数
		var getMonthArr	=	function(year){
			var arr;
			arr	=	[31,isLeapYear(year)?29:28,31,30,31,30,31,31,30,31,30,31];
			return arr;
		};
		//超过1900-2099年范围处理
		var outOfDates	=	function(option){
			// Y M D H 指当前显示的时间精确度
			if(option == "Y"){
				nowYear == 1900	&&	$this.find('div.w_left').html("");
				nowYear == 2099	&&	$this.find('div.w_right').html("");
			}
			else if(option == "YM"){
				nowYear == 1900	&&	nowMonth == 0	&&	$this.find('div.w_left').html("");
				nowYear == 2099	&&	nowMonth == 11	&&	$this.find('div.w_right').html("");
			}
			else if(option == "YMD"){
				nowYear == 1900	&&	nowMonth == 0	&&	nowDate == 1	&&	$this.find('div.w_left').html("");
				nowYear == 2099	&&	nowMonth == 11	&&	nowDate == 31	&&	$this.find('div.w_right').html("");
			}
			else if(option == "YMDH"){
				nowYear == 1900	&&	nowMonth == 0	&& nowDate == 1		&&	nowHour	== 0	&&	$this.find('div.w_left').html("");
				nowYear == 2099	&&	nowMonth == 11	&& nowDate == 31	&&	nowHour	== 23	&&	$this.find('div.w_right').html("");
			}
			else if(option =="YS"){
				$this.find('ul.years li').eq(0).html() == 1900	&&	$this.find('div.w_left').html("");
				$this.find('ul.years li').eq(0).html() == 2090	&&	$this.find('div.w_right').html("");
			};
		};
		//print dates
		var printYMD	=	function(){
			printYearMonth();
			printDays();
		};
		var printHour	=	function(){
			var //hour24	=	[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
				html	=	"<div class='w_dateTime'>"	+
								"<div class='w_right J_w_nextDate'>></div>"	+
								"<div class='w_left J_w_prevDate'><</div>"	+
								"<div class='w_yearMonth J_w_hour'>"	+
									nowYear	+	"年"	+	(nowMonth+1)	+	"月"	+	nowDate	+	"日"	+
								"</div>"	+
							"</div>"	+
							"<div class='w_dateContainer'>"	+
								"<div class='w_title'>"	+	"时间（24小时）"	+	"</div>"	+
								"<div class='w_selectBox'>"	+
									"<ul class='hour'>";
			for(var i	=	0;	i	<	24;	i++){
				var obj	=	{"year" : nowYear,	"month" : nowMonth+1,	"date" : nowDate,	"hour" : i};
				if(beforeEndDate(obj,4)	&&	afterStartDate(obj,4)){
					if(nowYear == today.getFullYear()	&&	nowMonth == today.getMonth()	&&	nowDate == today.getDate()	&&	i == today.getHours()){
						html	+=	"<li class='today' data-hour='"	+	i	+	"'>"	+	i	+	"</li>";
					}
					else{
						html	+=	"<li data-hour='"	+	i	+	"'>"	+	i	+	"</li>";
					};
				}
				else{
					html	+=	"<li class='gray'>"	+	i	+	"</li>";
				};
			};
			html	+=	"</ul></div></div>";
			$this.html(html);
			outOfDates("YMD");
		};
		var printMinute	=	function(){
			var //minute	=	["00","05","10","15","20","25","30","35","40","45","50","55"],
				html	=	"<div class='w_dateTime'>"	+
								"<div class='w_right J_w_nextHour'>></div>"	+
								"<div class='w_left J_w_prevHour'><</div>"	+
								"<div class='w_yearMonth J_w_minute'>"	+
									nowYear	+	"年"	+	(nowMonth+1)	+	"月"	+	nowDate	+	"日"	+
								"</div>"	+
							"</div>"	+
							"<div class='w_dateContainer'>"	+
								"<div class='w_title'>"	+	"时间（分钟）"	+	"</div>"	+
								"<div class='w_selectBox'>"	+	"<ul class='minute'>";
			for(var i	=	0;	i	<	60;	i++){
				var obj	=	{"year" : nowYear,	"month" : nowMonth+1,	"date" : nowDate,	"hour" : nowHour,	"minute" : i};
				if(beforeEndDate(obj,5)	&&	afterStartDate(obj,5)){
					if(nowYear == today.getFullYear()	&&	nowMonth == today.getMonth()	&&	nowDate == today.getDate()	&&	nowHour	==	today.getHours()	&&	i ==	today.getMinutes()){
						html	+=	"<li class='today' data-minute='"	+	i	+	"'>"	+	nowHour	+	":"	+	intToString(i)	+	"</li>";
					}
					else{
						html	+=	"<li data-minute='"	+	i	+	"'>"	+	nowHour	+	":"	+	intToString(i)	+	"</li>";
					};
				}
				else{
					html	+=	"<li class='gray'>"	+	nowHour	+	":"	+	intToString(i)	+	"</li>";
				};
			};
			html	+=	"</ul></div></div>";
			$this.html(html);
			outOfDates("YMDH");
		};
		var printYears	=	function(year){
			var html	=	"<div class='w_dateTime'>"	+
								"<div class='w_right J_w_nextYears'>"	+
									">"	+
								"</div>"	+
								"<div class='w_left J_w_prevYears'>"	+
									"<"	+
								"</div>"	+
								"<div class='w_yearMonth'>"	+
										year	+	"-"	+	(year	+	9)	+
								"</div>"	+
							"</div>"	+
							"<div class='w_dateContainer'>"	+
								"<div class='w_title'>"	+	"选择年份"	+	"</div>"	+
								"<div class='w_selectBox'>"	+
									"<ul class='years'>";
			for(var i	=	0;	i	<	10;	i++){
				if(parseInt(year+i)	>=	startDate.year	&&	parseInt(year+i)	<=	endDate.year){
					if( year	+	i	==	today.getFullYear()){
						html	+=			"<li class='today' data-year='"	+	parseInt(year	+	i)	+	"'>"	+	parseInt(year	+	i)	+	"</li>";
					}
					else{
						html	+=			"<li data-year='"	+	parseInt(year	+	i)	+	"'>"	+	parseInt(year	+	i)	+	"</li>";
					};
				}
				else{
					html	+=	"<li class='gray'>"	+	parseInt(year	+	i)	+	"</li>";
				};
			};
			html	+=				"</ul>"	+
								"</div>"	+
							"</div>";
			$this.html(html);
			outOfDates("YS");
		};
		var printIt		=	function(){
			switch	(startingPosition){
				case	1:
					printYears(nowYear	-	nowYear	%	10);
					break;
				case	2:
					printMonth();
					break;
				case	3:
					printYMD();
					break;
				case	4:
					printHour();
					break;
				case	5:
					printMinute();
					break;
			};
		};
		var setPosition	=	function(){
			var _padding	=	$input.css('padding-right').split('px')[0];
			if(_padding == 0){_padding	=	5;}
			$this.css({
				'top'	:	$input.offset().top	+	$input.outerHeight(true),
				'left'	:	$input.offset().left
			}).attr('tabindex','-1');
			_icon	&&	$icon.css({
				'top'	:	$input.offset().top + $input.outerHeight(true) / 2	-	$icon.height() / 2,
				'left'	:	$input.offset().left	+	$input.outerWidth(true)	-	$icon.width()	-	_padding	-	1
			}).attr('tabindex','-1');
		};
		//初始化
		this.init	=	function(){
			setPosition();
			if(setting){
				startingPosition	=	setting.startingPosition;
				maxAccording		=	setting.maxAccording;
				minAccording		=	setting.minAccording;
				autoClose			=	setting.autoClose;
				icon				=	setting.icon;
			}
			printIt();
		};
		var	prevMonth	=	function(){
			if(nowMonth == 0){
				nowYear--;
				nowMonth	=	11;
			}
			else{
				nowMonth--;
			};
			printYMD();
		};
		var	nextMonth	=	function(){
			if(nowMonth == 11){
				nowYear++;
				nowMonth	=	0;
			}
			else{
				nowMonth++;
			};
			printYMD();
		};
		var nextDate	=	function(){
			if(nowDate == getMonthArr(nowYear)[nowMonth]){
				nextMonth();
				nowDate	=	1;
			}
			else{
				nowDate++;
			};
			printHour();
		};
		var prevDate	=	function(){
			if(nowDate == 1){
				prevMonth();
				nowDate	=	getMonthArr(nowYear)[nowMonth];
			}
			else{
				nowDate--;
			};
			printHour();
		};
		var prevHour	=	function(){
			if(nowHour ==	0){
				nowHour	=	23;
				prevDate();
			}
			else{
				nowHour--;
			}
			printMinute();
		};
		var nextHour	=	function(){
			if(nowHour == 23){
				nowHour	=	0;
				nextDate();
			}
			else{
				nowHour++;
			};
			printMinute();
		};
		//检查参数日期格式，正确则返回一个json格式日期
		var	dateIsValid	=	function(date){
			if(typeof date === "string"){
				var str	=	/^((19\d{2})|(20\d{2}))\-((0?[1-9])|(1[0-2]))\-((0?[1-9])|([1-2][0-9])|(3[0-1]))(\s((0?[0-9])|(1[0-9])|(2[0-3]))\:[0-5][0-9])?$/g;
				if(date.match(str)){
					var	arr			=	date.split(" "),
						dateInfo	=	arr[0].split("-"),
						countDate	=	getMonthArr(dateInfo[0])[parseInt(dateInfo[1])-1],
						setDate		=	{};
					if(dateInfo[2]	<=	countDate){
						$.extend(setDate,{"date":parseInt(dateInfo[2])});
					}
					else{
						console.warn("参数日期超出范围,",dateInfo[2]);
						$.extend(setDate,{"date":countDate});
					};
					if(arr.length	>	1){
						var time	=	arr[1].split(":");
						$.extend(setDate,{"hour":parseInt(time[0]),"minute":time[1]});
					};
					$.extend(setDate,{"year":parseInt(dateInfo[0]),"month":parseInt(dateInfo[1])});
					return setDate;
				}
				else{
					console.error("请检查参数格式(1900~2099)：yyyy-mm-dd or yyyy-mm-dd hh:mm,",date);
					return false;
				};
			}
			else{
				console.error("请设置参数类型：string,",date,typeof date);
				return false;
			};
		};
		//判断时间大小
		var checkDates	=	function(option1,option2){
			var a	=	new Date(),
				b	=	new Date();
			option1.year	&&	a.setFullYear(option1.year);
			option1.month	&&	a.setMonth(option1.month-1);
			option1.date	&&	a.setDate(option1.date);
			option1.hour	&&	a.setHours(option1.hour);
			option1.minute	&&	a.setMinutes(option1.minute);

			option2.year	&&	b.setFullYear(option2.year);
			option2.month	&&	b.setMonth(option2.month-1);
			option2.date	&&	b.setDate(option2.date);
			option2.hour	&&	b.setHours(option2.hour);
			option2.minute	&&	b.setMinutes(option2.minute);

			return (a.valueOf()	<	b.valueOf())	?	true	:	false;
		};
		//起始时间大于终止时间时，防止出错，互换数据
		var swapDate	=	function(date1,date2){
			console.warn("起始时间大于终止时间,startDate",startDate,"endDate,",endDate);
			var temp	=	$.extend({},date1);
			$.extend(date1,date2);
			$.extend(date2,temp);
		};
		this.setEndDate	=	function(date){
			//setting before 'date' is usable
			$.extend(endDate,dateIsValid(date));
			!checkDates(startDate,endDate)	&&	swapDate(startDate,endDate);
			//设置后刷新当前页面显示内容 如果没有隐藏的话
			printIt();
		};
		this.setStartDate	=	function(date){
			//setting after 'date' is usable
			$.extend(startDate,dateIsValid(date));
			!checkDates(startDate,endDate)	&& swapDate(startDate,endDate);
			//设置后刷新当前页面显示内容
			printIt();
		};
		this.show	=	function(option){
			if(option){
				if($input.val()){
					var	showDate	=	dateIsValid($input.val());
					showDate.hour	+=	"";
					if(showDate.year){
						nowYear	=	showDate.year;
						today.setFullYear(showDate.year);
					};
					if(showDate.month){
						nowMonth	=	showDate.month	-	1;
						today.setMonth(showDate.month-1);
					};
					if(showDate.date){
						nowDate	=	showDate.date;
						today.setDate(showDate.date);
					};
					if(showDate.hour.length){
						nowHour	=	showDate.hour;
						today.setHours(showDate.hour);
					};
					if(showDate.minute){
						nowMinute	=	showDate.minute;
						today.setMinutes(showDate.minute);
					};
				};
				$this.show();
				_icon	&&	$icon.attr('class','date_show');
				printIt();
			}
			else{
				if(!$this.is($('.w_dateBox:visible'))){
					that.show(true);
				}
			};
			$this.focus();
		};
		var intToString	=	function(number){
			var str;
			if(number	<=	9){
				str	=	"0"	+	number;
			}
			else{
				str	=	number	+	"";
			};
			return str;
		};
		this.update	=	function(){
			var	now	=	"";
			if(minAccording	>	0){
				now	+=	nowYear;
				if(minAccording	>	1){
					now	+=	"-"	+	intToString(parseInt(nowMonth+1));
					if(minAccording	>	2){
						now	+=	"-"	+	intToString(nowDate);
						if(minAccording	>	3){
							if(minAccording == 4){
								now	+=	" "	+	intToString(nowHour)	+	":00";
							}
							else	if(minAccording == 5){
								now	+=	" "	+	intToString(nowHour)	+	":"	+	intToString(nowMinute);
							};
						};
					};
				};
			};
			$input.val(now);
			autoClose	&&	$this.hide()	&&	_icon	&&	$icon.attr('class','date_default');
		};
		$this.on('click','.J_w_nextMth',function(){
			//日历下切换月份
			$(this).html()	&&	nextMonth();
		}).on('click','.J_w_prevMth',function(){
			//日历下切换月份
			$(this).html()	&&	prevMonth();
		}).on('click','[data-date]',function(){
			//日历下点击日期显示时间
			nowDate	=	parseInt($(this).attr('data-date'));
			if(minAccording	>	3){
				printHour();
			}
			else{
				that.update();
			};
		}).on('click','[data-hour]',function(){
			//时间下点击时段选择分
			nowHour	=	parseInt($(this).attr('data-hour'));
			if(minAccording	>	4){
				printMinute();
			}
			else{
				that.update();
			};
		}).on('click','.J_w_nextDate',function(){
			//hour 下切换 date
			$(this).html()	&&	nextDate();
		}).on('click','.J_w_prevDate',function(){
			$(this).html()	&&	prevDate();
		}).on('click','.J_w_hour',function(){
			maxAccording	<	4	&&	printYMD();
		}).on('click','.J_w_minute',function(){
			maxAccording	<	5	&&	printHour();
		}).on('click','.J_w_prevHour',function(){
			$(this).html()	&&	prevHour();
		}).on('click','.J_w_nextHour',function(){
			$(this).html()	&&	nextHour();
		}).on('click','[data-minute]',function(){
			nowMinute	=	$(this).attr('data-minute');
			that.update();
			//write into input text
		}).on('click','.J_w_month',function(){
			//日历下点击年月显示月历
			maxAccording	<	3	&&	printMonth();
		}).on('click','.J_w_nextYear',function(){
			//月历下切换年份
			if($(this).html()){
				nowYear++;
				printMonth();
			};
		}).on('click','.J_w_prevYear',function(){
			//月历下切换年份
			if($(this).html()){
				nowYear--;
				printMonth();
			};
		}).on('click','[data-month]',function(){
			//月历下点击月份显示日历
			nowMonth	=	parseInt($(this).attr('data-month'));
			if(minAccording	>	2){
				printYMD();
			}
			else{
				that.update();
			};
		}).on('click','.J_w_year',function(){
			//月历下点击年份显示当前年份后10年
			maxAccording	<	2	&&	printYears(nowYear	-	nowYear	%	10);
		}).on('click','.J_w_nextYears',function(){
			//月历下点击年份显示当前年份后10年
			$(this).html()	&&	printYears(parseInt($this.find('li').eq(0).html())+10);
		}).on('click','.J_w_prevYears',function(){
			//月历下点击年份显示当前年份后10年
			$(this).html()	&&	printYears(parseInt($this.find('li').eq(0).html())-10);
		}).on('click','[data-year]',function(){
			//月历下点击年份显示当前年份月历
			nowYear	=	parseInt($(this).html());
			if(minAccording	>	1){
				printMonth();
			}
			else{
				that.update();
			};
		}).on('blur',function(){
			//坑爹IE8 我服！
			timeout	=	setTimeout(function(){
				$this.hide();
				_icon	&&	$icon.attr('class','date_default');
			},200);
			//that.update();
		}).on('click',function(){
			clearTimeout(timeout);
			$this.focus();
		}).on('focus',function(){
			clearTimeout(timeout);
			//$this.show();
		});

		$(window).on('resize',function(){
			setPosition();
		});
	};
	$.fn.extend({
		"dateBox"	:	function(option1,option2){
			var defaults	=	{
					"startingPosition"	:	3,
					"maxAccording"		:	1,
					"minAccording"		:	5,
					"autoClose"			:	false,
					"icon"				:	false,
				};
			if(!$(this).data('w_date')){
				for(var	key in option1){
					if(key	==	"startingPosition"	||	key	==	"minAccording"	||	key	==	"maxAccording"){
						if(option1[key]	>	5	||	option1[key]	<	1){
							console.warn("配置参数超出范围(number:1~5)：",key,option1[key],typeof option1[key]);
							option1[key]	=	defaults[key];
						};
					}
					else	if(key	==	"autoClose"	||	key == "icon"){
						if(typeof option1[key]	!=	"boolean"){
							console.warn("配置参数类型错误(boolean)：",key,option1[key],typeof option1[key]);
							option1[key]	=	defaults[key];
						}
					};
				};
				var ops	=	$.extend({},defaults,option1);
				this.each(function(){
					$('body').append("<div class='w_dateBox'></div>");
					var $box	=	$('.w_dateBox:last');
					$box.attr('data-pickerindex',$(this).attr('data-pickerindex'));
					if(option1.icon == true){
						$('body').append("<i class='date_default'></i>");
						var	$icon	=	$('i.date_default:last');
						$icon.attr('data-pickerindex',$(this).attr('data-pickerindex'));
						$(this).data('w_date',new w_Date(this,ops,$box,$icon));
					}
					else{
						$(this).data('w_date',new w_Date(this,ops,$box));
					}
				});
			}
			else	if(typeof option1	===	"string"	&&	typeof	$(this).data('w_date')[option1]	===	"function"){
				($(this).data('w_date')[option1])(option2);
			};
			return this;
		}
	});
	/**************
	时间控件结束
	**************/

	/**************
	时间控件范例
	**************/

	//单个时间控件调用
	(function(){
		if(!$('[data-pickerindex="demo-3"]').length) return false;
		//带参数初始化控件
		$('input[data-pickerindex]').dateBox({
			"startingPosition"	:	3,
			"maxAccording"		:	1,
			"minAccording"		:	5,
			"autoClose"			:	true,
			"icon"				:	true
		}).dateBox("init");
		//使用默认参数初始化
		//$('input[data-pickerindex]').dateBox().dateBox("init");
		//对所有时间控件适用的打开方式
		$(document).on('click','[data-pickerindex]',function(){
			if(!$(this).is('div')){
				var $this	=	$(this),
					_index	=	$this.data('pickerindex'),
					$input	=	$('input[data-pickerindex='	+	_index	+	']'),
					$thisbox	=	$('div[data-pickerindex='	+	_index	+	']');

				$input.dateBox('show');
			};
		});
	})();

	//两个时间控件带起始时间-截止时间的调用
	(function(){
		if(!$('[data-pickerorg="w_demo"]').length) return false;
		$('input[data-pickerindex]').dateBox({
			"startingPosition"	:	3,
			"maxAccording"		:	1,
			"minAccording"		:	5,
			"autoClose"			:	true,
			"icon"				:	true
		});
        $('input[data-pickerindex]').each(function(){
            $(this).dateBox("init");
        });
		$(document).on('click','[data-pickerorg][data-pickertype="start"]',function(){
			if(!$(this).is('div')){
				var $this	=	$(this),
					_index	=	$this.data('pickerindex'),
					_org	=	$this.data('pickerorg'),
					$input	=	$('input[data-pickerindex='	+	_index	+	']'),
					$that	=	$('input[data-pickerorg='	+	_org	+	'][data-pickertype="end"]'),
					$thisbox	=	$('div[data-pickerindex='	+	_index	+	']'),
					$thatbox	=	$('div[data-pickerorg='	+	_org	+	'][data-pickertype="end"]');
				//设置截止时间
				$that.val()	&&	$input.dateBox('setEndDate',$that.val());
			};
		}).on('click','[data-pickerorg][data-pickertype="end"]',function(){
			if(!$(this).is('div')){
				var $this	=	$(this),
					_index	=	$this.data('pickerindex'),
					_org	=	$this.data('pickerorg'),
					$input	=	$('input[data-pickerindex='	+	_index	+	']'),
					$that	=	$('input[data-pickerorg='	+	_org	+	'][data-pickertype="start"]'),
					$thisbox	=	$('div[data-pickerindex='	+	_index	+	']'),
					$thatbox	=	$('div[data-pickerorg='	+	_org	+	'][data-pickertype="start"]');
				//设置起始时间
				$that.val()	&&	$input.dateBox('setStartDate',$that.val());
			};
		});
	})();
	/**************
	时间控件范例结束
	**************/
})(jQuery,document);
